import React from 'react';
import ServicesHero from '../components/ServicesHero';
import StructureService from '../components/StructureService';
import AccountingService from '../components/AccountingService';
import ManagementConsultingService from '../components/ManagementConsultingService';
import TechnologyService from '../components/TechnologyService';
import MarketingService from '../components/MarketingService';
import LegalService from '../components/LegalService';
import HRService from '../components/HRService';
import GovServices from '../components/GovServices';
import ForeignBusinessService from '../components/ForeignService';
import AuditingService from '../components/AuditingService';

const Services: React.FC = () => {

  return (
    <div style={{ margin: 0, padding: 0 }}>

        <ServicesHero />
        <ManagementConsultingService />
        <StructureService />
        <GovServices />
        <HRService />
        <AccountingService />
        <TechnologyService />
        <AuditingService />
        <MarketingService />
        <LegalService />
        <ForeignBusinessService />

    </div>
  );
};

export default Services;
